import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { visitPaths } from '~libs.desktop.shared.paths';

import { patientGroupFilterStorage } from '../AppointmentsFilterPanel/fields/PatientGroupField/PatientGroupField.storage';
import { useAppointmentsFiltersContext } from '../AppointmentFilter.context';

import { ChipFilter } from './ChipFilter';
import { usePatientGroupsFilterLabel } from './PatientGroupsFilter.hooks';

type PatientGroupsFilterProps = {
   readonly patientGroups: PatientGroup[];
};

export const PatientGroupsFilter = (props: PatientGroupsFilterProps): JSX.Element | null => {
   const selectedPatientGroupIds = useAppointmentsFiltersContext().getFilter('patientGroup');
   const label = usePatientGroupsFilterLabel(selectedPatientGroupIds, props.patientGroups);

   if (selectedPatientGroupIds.length === 0) {
      return null;
   }

   return (
      <ChipFilter
         label={label}
         searchParamKey={visitPaths.PATIENT_GROUP_SEARCH_PARAM}
         testId={'patientGroupsFilter'}
         onClick={patientGroupFilterStorage.removeFilter}
         hideExcessiveLabel
      />
   );
};
